module.exports = __webpack_public_path__ + "img/dots-right-new.938a8a9d.png";